

























































import { NullableString } from "@/code/Types";
import { Component } from "vue-property-decorator";
import BasePage from "@/views/base/BasePage";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import { OpportunityData } from "@/models/OpportunityData";
import { clientsStore } from "@/store/modules/ClientStore";
import { Routes } from "@/router/Routes";
import { accountStore } from "@/store/modules/AccountStore";
import { Helpers } from "@/code/Helpers";

@Component
export default class extends BasePage {
  search: NullableString = null;

  headers = [
    { text: "Insured Name", value: "clientName" },
    { text: "Product Group", value: "opportunityProductLine" },
    { text: "Carrier", value: "insurance" },
    { text: "Product", value: "productType" },
    { text: "Face", value: "faceAmount" },
    { text: "Premium", value: "annualizedPremium" },
    {
      text: "Effective Date",
      value: "",
      sort: (a: NullableString, b: NullableString): number =>
        Helpers.sortDate(a, b),
    },
    { text: "Financial Advisor", value: "agentFullName" },
  ];

  get inForceOpportunity(): OpportunityData[] {
    return opportunityStore.inForceEntities;
  }

  get clientName(): NullableString {
    return `${clientsStore.current.clientFirstName} ${clientsStore.current.clientLastName}`;
  }
  async showCaseDetail(id: string): Promise<void> {
    await this.$router.push({
      name: Routes.NEW_BUSINESS_CASE_DETAIL,
      params: { id },
    });
  }
  get agentFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }
}
